<template>
  <div>
    <el-row
      :class="{'term-row': index>0}"
      v-for="(item,index) in courseRecords"
      v-bind:key="index"
    >
      <el-col
        :span="24"
        :xs="24"
      >
        <el-table
          ref="termCourses"
          :data="item.CourseList"
          :header-row-class-name="'el-table-header'"
          :cell-class-name="cellStyle"
        >
          <el-table-column
            prop="CourseName"
            :label="getCourseColTitle(item)"
            class-name="courses-history-colmun-width"
          >
          </el-table-column>

        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.courses-history-colmun-width {
  min-width: 40px;
}

</style>

<script>
export default {
  props: {
    courseRecords: Array
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    getCourseColTitle(item) {
      if (item.CourseType == 3){
            return item.CategoryName + " " + item.TermName;
        }else if (item.CourseType == 2){
            return item.CategoryName ;
        }else{
            return item.TermName;
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherSpeedupCourseHistoryList.vue